import R from 'ramda';

import buildContent from '../utils';
import lightTableTemplate from './lightTable.tpl.html';

export class LightTable {
  $onChanges(changesObj) {
    const newColumns = changesObj.data && changesObj.data.columns;
    const newRows = changesObj.data && changesObj.data.rows;

    this.columns = R.values(newColumns || this.columns);
    this.rows = newRows || this.rows;
    this.removeColWidth = `${(60 / R.length(R.values(this.columns)))}px`;
    const numCols =
      this.isEditMode() ? R.length(R.values(this.columns)) + 1 : R.length(R.values(this.columns));
    this.defaultColumnWidth = Math.floor(100 / numCols);
  }

  hasTitle() {
    return !R.isNil(this.template) && !R.isNil(this.template.name)
      && !R.isEmpty(this.template.name);
  }

  getTitle() {
    return this.template.name;
  }

  isEditMode() {
    return !R.isNil(this.editMode) && this.editMode;
  }

  hasRows() {
    return R.values(this.rows).length > 0;
  }

  getColumnWidth(col) {
    return this.isEditMode() ? `calc(${col.attrs.width} - ${this.removeColWidth})` : col.attrs.width;
  }

  getEmptyListMessageKey() {
    return !R.isNil(this.emptyListMessageKey) && !R.isEmpty(this.emptyListMessageKey)
      ? this.emptyListMessageKey
      : 'TABLE_GENERIC_EMPTY_LIST';
  }

  addRow() {
    const content = buildContent(this.template);
    this.rows.push(content);
  }

  removeRow(rowIndex) {
    this.rows = R.remove(rowIndex, 1, this.rows);
  }
}

export const tctLightTable = {
  template: lightTableTemplate,
  controller: LightTable,
  bindings: {
    columns: '<',
    rows: '=',
    emptyListMessageKey: '<?',
    editMode: '<?',
    template: '<',
  },
};
